var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 73.18 72.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill: CurrentColor;}.cls-2{clip-path: url(#clip-path);}.cls-3{fill: CurrentColor;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-8.41 -8.57)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 90,
    height: 90
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 11") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "73.18 0 73.18 31.55 69.18 31.55 69.18 6.82 35.07 40.93 32.24 38.1 66.34 4 41.63 4 41.63 0 73.18 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "59.18 72.86 0 72.86 0 13.68 29.59 13.68 29.59 17.68 4 17.68 4 68.86 55.18 68.86 55.18 42.75 59.18 42.75 59.18 72.86"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternal);
export default __webpack_public_path__ + "static/media/external.59c04c64.svg";
export { ForwardRef as ReactComponent };